var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookFairLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 48,
    viewBox: "0 0 376 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12551_6290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.3 46.6387L226.715 46.6387L226.715 0.747242L208.3 0.74724L208.3 46.6387Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.189 23.693C182.653 19.5647 178.529 13.9773 178.529 0.747241L198.593 0.747243C198.593 11.664 198.942 20.4544 207.109 23.693C198.933 26.9315 198.593 35.7219 198.593 46.6387L178.529 46.6387C178.529 33.4087 182.653 27.8124 189.189 23.693Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.348 27.2074L144.808 27.2074L144.808 35.5262L120.719 35.5262L120.719 46.6387L163.223 46.6387L163.223 0.747243L144.808 0.747242L144.808 16.9223L125.348 16.9223L125.348 27.2074Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5743 46.6387L71.9893 46.6387L71.9893 0.747242L53.5743 0.74724L53.5743 46.6387Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.189 47.3773C318.773 47.3773 329.434 36.9676 329.434 23.7197C329.434 10.4719 318.773 -5.77034e-05 305.189 -5.88885e-05C291.605 -6.00736e-05 280.953 10.4096 280.953 23.7197C280.953 37.0299 291.614 47.3773 305.189 47.3773ZM305.189 15.6411C309.8 15.6411 313.42 19.1822 313.42 23.7019C313.42 28.2217 309.8 31.7361 305.189 31.7361C300.578 31.7361 296.958 28.195 296.958 23.7019C296.958 19.2089 300.578 15.6411 305.189 15.6411Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.747 47.3773C268.331 47.3773 278.992 36.9676 278.992 23.7197C278.992 10.4719 268.331 -5.77034e-05 254.747 -5.88885e-05C241.163 -6.00736e-05 230.511 10.4096 230.511 23.7197C230.511 37.0299 241.172 47.3773 254.747 47.3773ZM254.747 15.6411C259.358 15.6411 262.978 19.1822 262.978 23.7019C262.978 28.2217 259.358 31.7361 254.747 31.7361C250.136 31.7361 246.516 28.195 246.516 23.7019C246.516 19.2089 250.136 15.6411 254.747 15.6411Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9891 0.74724L74.9408 0.747239L88.846 46.6387L112.348 46.6387L126.253 0.747243L108.324 0.747242L106.335 9.11946L94.9232 9.11946L92.98 0.74724L92.9891 0.74724ZM96.9765 17.9365L104.254 17.9365L100.579 33.4443L96.9856 17.9365L96.9765 17.9365Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5244 23.693C26.1128 11.7619 19.3207 -0.000116484 0.667374 -0.000118112L0.667373 16.8422C4.70052 16.335 10.2002 19.6893 11.5843 23.1058C5.51629 24.8852 2.87641 29.3605 2.87641 34.4585C2.87641 41.0691 7.31288 46.6387 17.9274 46.6387L46.7002 46.6387L46.7002 0.747246L28.716 0.747245L28.716 36.754L25.5445 36.754C23.033 36.754 20.4848 35.4105 20.4848 31.8161C20.4848 28.2216 23.8579 25.0365 27.5244 23.693Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.369 23.6932C339.369 23.6932 331.853 26.2645 331.853 34.4588C331.853 41.0694 336.289 46.639 346.904 46.639L375.667 46.639L375.667 0.747488L346.895 0.747485C336.289 0.747484 331.844 6.3082 331.844 12.9277C331.844 21.122 339.36 23.6932 339.36 23.6932L339.369 23.6932ZM349.452 15.5612C349.452 11.9757 352 10.6233 354.512 10.6233L357.683 10.6233L357.683 36.7542L354.512 36.7542C352 36.7542 349.452 35.4108 349.452 31.8163C349.452 28.2219 352.019 25.1524 356.492 23.6843C352.019 22.2252 349.452 19.1468 349.452 15.5523L349.452 15.5612Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12551_6290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 47.3684,
    fill: "white",
    transform: "translate(0.66748)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookFairLogo);
export default __webpack_public_path__ + "static/media/BookFairLogo.f2e2b61bb5b012dedd57929096dbc851.svg";
export { ForwardRef as ReactComponent };